// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"c240c964","724":"e529258c","838":"60c0f383"}[chunkId] + ".css";
};